import { CONSUMPTION_TAX_RATE } from "@/preferences";
import EstimateItems from "./estimate-items";
import TotalPrice from "./total-price";
import Decimal from "decimal.js";

type EstimateId = number;

/**
 * 見積もり
 */
export default class Estimate {
  public constructor(
    public id: EstimateId = 0,
    public title: string = "",
    public attention: string = "",
    public mention: string = "",
    public projectId: number = 0,
    public projectName: string = "",
    public projectOwnerName: string = "",
    public projectClientName: string = "",
    public status: string = "created",
    public items: EstimateItems = new EstimateItems(),
    public taxRate: Decimal.Value = CONSUMPTION_TAX_RATE,
    public printsExcludeTax: boolean = false,
    public dateOfIssue: string = "",
    public deadline: string = ""
  ) {}

  public get subtotal(): TotalPrice {
    return new TotalPrice(this.items.totalPrice);
  }

  public get tax(): Decimal {
    return this.subtotal.tax(this.taxRate);
  }

  public get total() {
    return this.subtotal.withTax(this.taxRate);
  }

  public get loss(): TotalPrice {
    return new TotalPrice(this.items.totalLoss);
  }

  public get profitRate() {
    return new Decimal(100).minus(this.lossRate.toNumber());
  }

  public get lossTotal() {
    return new Decimal(this.subtotal.toNumber())
      .minus(this.loss.toNumber())
      .toNumber();
  }

  public get lossRate(): Decimal {
    if (this.subtotal.toNumber() === 0) {
      return new Decimal(0);
    }
    return new Decimal(this.loss.toNumber())
      .times(100)
      .div(this.subtotal.toNumber());
  }

  public toJSON(): any {
    return {
      id: this.id,
      title: this.title,
      attention: this.attention,
      mention: this.mention,
      projectId: this.projectId,
      projectName: this.projectName,
      projectClientName: this.projectClientName,
      staffName: this.projectOwnerName,
      status: this.status,
      taxRate: this.taxRate,
      lossRate: this.lossRate.toNumber().toFixed(2),
      subtotal: this.subtotal.toNumber(),
      total: this.total.toNumber(),
      tax: this.tax.toNumber(),
      loss: this.loss.toNumber(),
      lossTotal: this.lossTotal,
      profitRate: this.profitRate.toNumber().toFixed(2),
      printsExcludeTax: this.printsExcludeTax,
      items: this.items.toJSON(),
      dateOfIssue: this.dateOfIssue,
      deadline: this.deadline
    };
  }
}
